import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = 'Convert GPA to Turkish Grading System';
const DESCRIPTION = "Learn how to easily and accurately convert your university GPA to the Turkish system. Get details on the Turkish university grading system.";
const KEYWORDS = "Turkish university system, convert GPA, Turkish grading system, bachelor's GPA, master's GPA, university GPA, Turkey";
const OG_URL = 'https://do-calculate.com/calculator/en/gradetoturkey';
function GradeToTurkey() {
  const [originalValue, setOriginalValue] = useState('');
  const [convertedValue, setConvertedValue] = useState('');
  const [conversionType, setConversionType] = useState('grade');
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToTurkishGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "AA";
    } else if (gpa >= 3.5 && gpa < 4.0) {
      return "BA";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "BB";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "CB";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "CC";
    } else if (gpa >= 1.5 && gpa < 2.0) {
      return "DC";
    } else if (gpa >= 1.0 && gpa < 1.5) {
      return "DD";
    } else if (gpa >= 0.5 && gpa < 1.0) {
      return "FD";
    } else if (gpa >= 0.0 && gpa < 0.5) {
      return "FF";
    } else {
      return 'Invalid input';
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === 'grade') {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 25).toFixed(2);
      }
    } else if (conversionType === 'gpa') {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToTurkishGrade(gpa);
      }
    }
    return 'Invalid input';
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue('');
    setConvertedValue('');
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Discover how to effortlessly and precisely convert your university GPA (whether it's a percentage or cumulative) into the Turkish grading system with our advanced GPA calculator tool. This invaluable resource allows you to seamlessly convert GPA to the Turkish system, helping you understand how your grades translate internationally. Whether you're a student planning to study in Turkey or someone needing to convert grades for academic or professional purposes, our GPA conversion tool provides accurate results quickly.
                </p>
                <p>
                  With our easy-to-use GPA calculator, you can ensure that you’re fully informed about how your academic performance compares within the Turkish educational framework. This tool is essential for students looking to align their academic records with international standards or for those who need to understand their GPA’s equivalent in Turkey. Utilize our GPA conversion tool to make informed decisions about your educational and professional journey.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>Convert University GPA to Turkish System</h2>
                </div>
                <hr />
                <div className="form-group">
                  <b><label>Conversion Type:</label></b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === 'grade'}
                      onChange={() => handleConversionTypeChange('grade')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gradeConversion" className="form-check-label">Percentage (100)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === 'gpa'}
                      onChange={() => handleConversionTypeChange('gpa')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">Cumulative (4.00)</label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label htmlFor='originalValue'>{conversionType === 'grade' ? 'Percentage GPA:' : 'Cumulative GPA:'}</label></b>
                    <input
                      type="text"
                      value={originalValue}
                      id='originalValue'
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className='form-control'
                      style={{ width: '200px', marginRight: '4px' }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Calculate                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                {showResult &&  (
                  <div style={{ fontSize: '15px' }} className="bg-light bg-gradient text-dark">
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Result:</strong>
                    </div>
                    <b>
                      {conversionType === 'grade'
                        ? `Percentage GPA in Turkish System: ${convertedValue}`
                        : `Turkish Grade Equivalent: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600} />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Turkish University Grading System</h2></u>
                  <p>
                    In Turkey, grades are classified on a scale from AA to FF, with AA being the best and FF being the worst. The grades are divided as follows:
                  </p>
                  <table >
                    <thead>
                      <tr className='bmi-header'>
                        <th>GPA (on a 4-point scale)</th>
                        <th>Turkish Grade</th>
                        <th>Equivalent Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>4.0</td>
                        <td>AA</td>
                        <td>90-100%</td>
                      </tr>
                      <tr>
                        <td>3.5 - 3.9</td>
                        <td>BA</td>
                        <td>85-89%</td>
                      </tr>
                      <tr>
                        <td>3.0 - 3.4</td>
                        <td>BB</td>
                        <td>80-84%</td>
                      </tr>
                      <tr>
                        <td>2.5 - 2.9</td>
                        <td>CB</td>
                        <td>75-79%</td>
                      </tr>
                      <tr>
                        <td>2.0 - 2.4</td>
                        <td>CC</td>
                        <td>70-74%</td>
                      </tr>
                      <tr>
                        <td>1.5 - 1.9</td>
                        <td>DC</td>
                        <td>65-69%</td>
                      </tr>
                      <tr>
                        <td>1.0 - 1.4</td>
                        <td>DD</td>
                        <td>60-64%</td>
                      </tr>
                      <tr>
                        <td>0.5 - 0.9</td>
                        <td>FD</td>
                        <td>55-59%</td>
                      </tr>
                      <tr>
                        <td>0.0 - 0.4</td>
                        <td>FF</td>
                        <td>0-54%</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    This information helps in understanding how to convert GPAs to the Turkish system and what their equivalent percentages are.
                  </p>
                  <b className='text-primary'>
                    <span>Example: </span>
                    If you have a GPA of 3.0 on a 4.0 scale, you can use the tool above to convert it to the Turkish system and get the equivalent result.
                  </b>
                  <p>
                    This tool is very useful for international students who want to continue their studies in Turkey or apply for jobs that require a certain GPA.
                  </p>
                  <div>
                    <p>
                      Turkey is one of the countries witnessing continuous scientific development, with many prestigious universities attracting students from all over the world.
                    </p>
                    <p className='alert alert-info'>
                      Turkey has many globally ranked universities, and the academic system in Turkish universities is characterized by scientific rigor and innovation in curricula. The tuition fees in Turkey are reasonable compared to other European countries and the United States.
                    </p>
                  </div>
                </div>
                <br/>              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToTurkey;
